export default function getCSSColor(color: string) {
  const cssValue = getComputedStyle(document.documentElement).getPropertyValue(`--pcse-color-${color}`);
  const rgb = cssValue.split(",").map(v => v.trim());
  const alpha = rgb[3] === undefined ? 1 : rgb[3];
  const rgbString = `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${alpha})`;
  return rgbString;
}
